
<template>
	<FormGroupBox title="Promociones">
		<template #append-title>
			<b-button class="ml-2" size="sm" variant="success" @click="newPromotion" :disabled="!$hasPermission(permision)">
				<md-icon icon="add"/>Crear
			</b-button>
		</template>
		<div class="d-flex flex-column w-100 p-2">
		<!-- <div class="d-flex w-100 justify-content-end">
			<b-button variant="primary" @click="newPromotion">Nueva promoción</b-button>
		</div> -->
		<div class="d-flex w-100" v-if="$hasPermission(permision)">
			<b-overlay :show="loading" class="m-3 mx-auto"></b-overlay>
			<b-table
				v-if="!loading"
				class="w-100 mt-3"
				stacked="sm"
				responsive="md"
				striped
				small
				hover
				bordered
				:fields="columnsPromotions"
				:items="itemsPromotions">
				<template v-slot:cell(travelWindow)="row" >
					<small>{{getDateData('travelWindow',row)}}</small>
				</template>
				<template v-slot:cell(bookingWindow)="row" >
					<small>{{getDateData('bookingWindow',row)}}</small>
				</template>
				<template v-slot:cell(assignedWindow)="row">
					<small>{{getDateData('assignedWindow',row)}}</small>
				</template>
				<template v-slot:cell(type)="{item}">
					<span>{{rateModifierTypeText(item.rateModifierType)}}</span>
				</template>
				<template  v-slot:cell(amount)="{item}">
					<b-button
						@click="(event) => viewdetail(item)"
						type="button"
						size="sm"
						variant="info"
						content="Ver Configuración"
						v-tippy="{ arrow: true, arrowType: 'round' }"
					>
						<md-icon icon="list" />
					</b-button>
				</template>
				<template  v-slot:cell(token)="{item}">
					<div class="text-center">
						<b-badge pill variant="success" v-if="!$root.isEmpty(item.token)">{{item.token}}</b-badge>
						<small class="text-muted" v-if="item.tokenLimit>0">Limitado a <b>{{item.tokenLimit}}</b> rides</small>
						<small class="text-muted" v-else>Sin Limite de uso.</small>
					</div>

				</template>
				<template v-slot:cell(actions)="row">
					<div class="text-center">
						<b-button
							@click="(event) => viewPromotion(row.item.id)"
							type="button"
							size="sm"
							:disable="!$hasPermission(permision)"
							variant="info"
							content="Editar promocion"
							v-tippy="{ arrow: true, arrowType: 'round' }"
						>
								<md-icon icon="edit" />
						</b-button>
						<b-button
							v-if="$hasPermission(permision)"
							@click="(event) => deletePromotion(row.item)"
							type="button"
							size="sm"
							class="ml-1"
							variant="danger"
							content="Eliminar promocion"
							v-tippy="{ arrow: true, arrowType: 'round' }">
								<md-icon icon="delete" />
						</b-button>
					</div>
				</template>
			</b-table>
		</div>

		<div class="d-flex w-100" v-else>
			<h1>Sin permisos para visualizar datos</h1>
		</div>

		<!-- modal cierre de tarifa -->
		<b-modal
			hide-footer
			ref="refSingleForm"
			size="xl"
			:title="promotionEdit==null? 'Nueva Promoción' : 'Editar Promoción'">
			<SingleForm
				:embbebedOnId="salesChannelId"
				:embbebedOn="'sales-channel'"
				:promotionEdit="promotionEdit"
				@closeModal="$refs['refSingleForm'].hide()"
				@refreshTable="refreshTable()"/>
				</b-modal>
		<b-modal
			hide-footer
			ref="refViewAmounts"
			size="lg"
			title="Detalle de tarifa">
				<DetailPromotion ref="detailOfPromotion"></DetailPromotion>
		</b-modal>

		</div>

	</FormGroupBox>

</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
//import SingleForm from "./SingleForm.vue"
import SingleForm from "@/components/sections/promotions/SingleForm.vue"
import DetailPromotion from "@/components/sections/promotions/DetailPromotion.vue"
export default {
	props:{
		salesChannelId:{
			type: [String, Number],
			required: true
		}
	},
	components: {
		SingleForm, FormGroupBox,DetailPromotion
	},
	data(){
		return{
			loading:false,
			permision: "channel.ratePlan",
			columnsPromotions: [
				{ key: "id", label: "Id" },
				{ key: "name", label: "Nombre" },
				{ key: "code", label: "Codigo", sortable: true },
				{ key: "ratePlanData.title", label: "Rate plan"},
				{ key: "bookingWindow", label: "Booking Window" },
				{ key: "travelWindow", label: "Travel Window" },
				{ key: "type", label: "Tipo" },
				{ key: "amount", label: "Monto", sortable: true },
				{ key: "token", label: "Cupon" },
				{ key: "qtyTokenRedeemed", label: "Qty canjeados"},
				{ key: "actions", label: "Acciones" },
			],
			columnsDetail: [
				{ key: "fromZone", label: "Zona origen" },
				{ key: "toZone", label: "Zona destino" },
				{ key: "serviceType", label: "Tipo de servicio" },
				{ key: "amount", label: "Monto" },
			],
			arrayDetails: [],
			arraypromotions:[],
			promotionEdit: null
		}

	},
	mounted(){
		this.getPromotions();

	},
	methods:{
		viewdetail (promotionInfo) {
			this.$refs['refViewAmounts'].show();
			setTimeout(()=>{
				this.$refs["detailOfPromotion"].setData(promotionInfo);
			},0)
		},
		formatCurrency(item){
			if(item.amount === undefined) return ''
			return Intl.NumberFormat('en-US').format(item.amount) + ' ' + item.currency.toUpperCase()
		},
		refreshTable(){
			this.getPromotions();
			this.$refs['refSingleForm'].hide();
		},
		deletePromotion(item){
			this.$bvModal.msgBoxConfirm('¿Esta seguro de eliminar la promocion: '+item.name+"?", {
				title: 'Eliminar registro',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'Si, continuar',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value){
					// eslint-disable-next-line no-unused-vars
					this.$root.api.delete(`/promotions/sales-channel/${this.salesChannelId}/${item.id}`).then((res) => {
						this.$root.showAlert(`Se elimino correctamente`);
						//refrescamos la tabla
						this.refreshTable();
					}).catch(this.$root.handleRequestError);
				}
			});
		},
		viewPromotion(idPromotion){
			this.$root.api.get(`/promotions/sales-channel/${this.salesChannelId}/${idPromotion}`).then((res) => {
					//guardamos los detalles de la promocion
					this.promotionEdit = res.data;
					//abrimos el modal
					this.$refs['refSingleForm'].show();
				}).catch(this.$root.handleRequestError);
		},
		getPromotions(){
			this.loading = true;
			this.$root.api.get(`/promotions/sales-channel/${this.salesChannelId}`).then((res) => {
					this.arraypromotions = res.data;
				})
				.catch(this.$root.handleRequestError)
				.finally(()=>{
					this.loading = false;
				})
		},
		newPromotion(){
			this.promotionEdit = null;
			this.$refs['refSingleForm'].show();
		},
		getDateData(typeOfDate,row){
			let cpRow = {...row.item}
			if (this.$root.isEmpty(cpRow['dates'][typeOfDate])) return "";
			let res = cpRow['dates'][typeOfDate].reduce((valueConcat,currentValue) => {
				if(valueConcat != "") valueConcat+=" ,\n"
				return valueConcat += currentValue.start+" - "+currentValue.end
			},"")
			return res
		},
		rateModifierTypeText(val){
			let text = val;
			switch(val){
				case "percent":
					text ="porcentaje";
					break;
				case "amount":
					text= "Monto"
					break;
				case "fixed_rate":
					text = "Tarifa fija"
					break;
			}
			return text
		}
	},
	computed: {
		itemsPromotions() {
			return this.arraypromotions.map(element => {
				if(element.attributes.expired){
					return {...element,...{_rowVariant: 'secondary'}}
				}
				return element;
			});

		}
    }
}
</script>

<style scoped>
/* lg */
@media screen and (min-width: 1000px) {
	.modal-dialog{
		width: 55%!important;
		max-width: 55%!important;
	}
}
/* md */
@media screen and (min-width: 720px) and (max-width: 899px)  {
	.modal-dialog{
		width: 75%!important;
		max-width: 75%!important;
	}
}
/* sm */
@media screen and (max-width: 719px) {
	.modal-dialog{
		width: 95%!important;
		max-width: 95%!important;
	}
}
</style>
